import { useQuery } from '@tanstack/react-query';
import ApiConfig from 'src/config/api-config';
import { deepCamelCaseKeys } from 'src/utils/deepCamelCaseKeys';
import { sessionStore } from 'src/store/sessionStore';
import { FetchedProgramPlan } from 'src/api/mutations/useGetTrainerProgramPlanList';

export const fetchTrainerProgramPlanById = async (
  trainerId: string,
  programId: string,
): Promise<FetchedProgramPlan> => {
  if (!trainerId || !programId) {
    throw new Error('Trainer ID or Program ID is missing');
  }

  const queryParams = new URLSearchParams({ trainerId, programId });
  const apiUrl = `${ApiConfig.CLOUD_FUNCTIONS_BASE_URL}${ApiConfig.TRAINER_GET_PROGRAM_PLAN_BY_ID}?${queryParams.toString()}`;

  const response = await fetch(apiUrl);

  if (!response.ok) {
    throw new Error(`Failed to fetch trainer program by id: ${response.status}`);
  }

  const res = await response.json();
  const parsedData = deepCamelCaseKeys(res.data);
  return parsedData as unknown as FetchedProgramPlan;
};

export function useGetTrainerProgramById(programId?: string, isEnabled: boolean = true) {
  const currentUser = sessionStore((s) => s.currentUser);
  const trainerId = currentUser?.uid;

  return useQuery({
    queryKey: ['trainer-program-plan', trainerId, programId],
    queryFn: () => fetchTrainerProgramPlanById(trainerId as string, programId as string),
    enabled: !!trainerId && !!programId && isEnabled,
  });
}
